/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Manage_Plan_Downgrade_BtnInputs */



/**
* | output |
* | --- |
* | "Schedule downgrade" |
*
* @param {Partner_Manage_Plan_Downgrade_BtnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_plan_downgrade_btn = /** @type {((inputs?: Partner_Manage_Plan_Downgrade_BtnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Plan_Downgrade_BtnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Downgrade planen")
	return /** @type {LocalizedString} */ ("Schedule downgrade")
});